import React from 'react';
import './ReferFriend.css';

const ReferFriend = () => {
  return (
    <div className="refer-friend-wrapper">
      <div className="refer-friend-title">Refer a Friend</div>
      <div className="refer-friend-content">
        Invite a friend to play & earn! You will get xxx when they xxxxx
      </div>
      <div className="refer-friend-link">Invite</div>
    </div>
  );
};

export default ReferFriend;
